import React from 'react';
import styled from 'styled-components';
import PropTypes from "prop-types";
import {ReactComponent as Circle} from "../../assets/circle.inline.svg";
import {ReactComponent as Triangle} from "../../assets/triangle.inline.svg";
import {ReactComponent as QuarterCircle} from "../../assets/quarterCircle.inline.svg";
import {ReactComponent as Square} from "../../assets/square.inline.svg";
import {ReactComponent as ReverseQuarterCircle} from "../../assets/reverse-quarter.inline.svg";
import {ReactComponent as Star} from "../../assets/star.inline.svg";
import {ReactComponent as Bubble} from "../../assets/bubble.inline.svg";
import {ReactComponent as CurvyDiagonal} from "../../assets/curvy-diagonal.inline.svg";
import {ReactComponent as Diamond} from "../../assets/diamond.inline.svg";

const Holder = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 2px;

  svg {
    display: block;
    width: 100%;
    height: 100%;
    path, ellipse, circle, rect, polygon {
      fill: var(--color-1);
    }
  }
`;


const shapes = [
  {
    id: "circle",
    component: <Circle />
  },
  {
    id: "quarterCircle",
    component: <QuarterCircle />
  },
  {
    id: "triangle",
    component: <Triangle />
  },
  {
    id: "square",
    component: <Square />
  },
  {
    id: "reverseQuarterCircle",
    component: <ReverseQuarterCircle />
  },
  {
    id: "star",
    component: <Star />
  },
  {
    id: "bubble",
    component: <Bubble />
  },
  {
    id: "curvyDiagonal",
    component: <CurvyDiagonal />
  },
  {
    id: "diamond",
    component: <Diamond />
  },
]

function ShapeButtons(props) {

  return (
    <Holder>
      {
        shapes.map((shape) => {
          return (
            <button key={shape.id} onClick={() => props.clickHandler('shape', shape.id)}>
              {shape.component}
            </button>
          )
        })
      }
    </Holder>
  )
}

ShapeButtons.propTypes = {
  clickHandler: PropTypes.func.isRequired,
};

export default ShapeButtons;